import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "change-model-content" }
const _hoisted_2 = { class: "form-item" }
const _hoisted_3 = { class: "phone-name" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = { class: "form-item" }

import { ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneChangeModelDialog',
  emits: ['changed'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const visible = ref(false);
const phoneId = ref('');
const phoneName = ref('');
const androidVersion = ref('');
const selectedBrand = ref('');
const selectedModel = ref('');
const resetData = ref(false);
const brandList = ref<any[]>([]);

const modelList = computed(() => {
  const brand = brandList.value.find(b => b.brand === selectedBrand.value);
  return brand?.models || [];
});

const show = async (id: string, name: string, version: string) => {
  phoneId.value = id;
  phoneName.value = name;
  androidVersion.value = version;
  selectedBrand.value = '';
  selectedModel.value = '';
  resetData.value = false;

  try {
    const res = await request.get(`/realphone/list?android_version=${version}`);
    brandList.value = res.data.data;
    visible.value = true;
  } catch (error) {
    console.error('获取机型列表失败:', error);
  }
};

const handleBrandChange = () => {
  selectedModel.value = '';
};

const handleClose = () => {
  visible.value = false;
};

const handleConfirm = async () => {
  if (!selectedModel.value) {
    ElMessage.warning('请选择云机机型');
    return;
  }
  try {
    const requestData: any = {
      model_id: selectedModel.value,
      instance_use_ids: [Number(phoneId.value)],
      clear_data: resetData.value ? 'true' : 'false'
    };
    await request.post('/realphone/batch_change_model', requestData);
    ElMessage.success('更换机型成功，云手机重启中');
    emit('changed');
    handleClose();
  } catch (error) {
    console.error('更换机型失败:', error);
  }
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "更换机型",
    width: "500px",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !selectedModel.value,
        onClick: handleConfirm
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("确认更换", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "云机名称", -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(phoneName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "产品品牌", -1)),
          _createVNode(_component_el_select, {
            modelValue: selectedBrand.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBrand).value = $event)),
            placeholder: "请选择产品品牌",
            onChange: handleBrandChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.brand,
                  label: item.brand,
                  value: item.brand
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "云机机型", -1)),
          _createVNode(_component_el_select, {
            modelValue: selectedModel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedModel).value = $event)),
            placeholder: "请选择云机机型",
            disabled: !selectedBrand.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.model,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_checkbox, {
            modelValue: resetData.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resetData).value = $event))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("重置云机数据", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})